import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { selectIsSuperAdmin } from "../../../store/selectors/session";
import { selectClientListTiny, selectSelectedClient, selectSelectedClientSchema } from "../../../store/selectors/clients";
import { listTiny } from '../../../store/actions/clients';

import CopyContractDialogComponent from './CopyContractDialog';
import { copyContract, setCopyContractName, copyContractReset, setCopyContractDialog } from '../../../store/actions/contracts';
import { getRulesByContractId, resetRulesByContractId } from '../../../store/actions/rules';
import { getFeeScheduleFromClient } from '../../../store/actions/feeScheduleItems';
import { getServicesFromTargetClient } from '../../../store/actions/services';
import { getFacilitiesByTargetClient } from '../../../store/actions/facilities';
import {getFeeScheduleLabelsFromTargetClient,validateLabelsFromTargetClient} from '../../../store/actions/feeScheduleV2';
import { getNPIRolesFromContract, getNPIRolesFromTargetClient, npiRolesLanding } from '../../../store/actions/npiRoles';

export const CopyContractDialog = connect(
    () => {
        const selectCopyContractName = (state) => state.contracts.copyContractName;
        const selectCopyContractDialog = (state, props) => state.contracts.copyContractDialog;

        const selectCopyContractDialogOpen = createSelector(
            selectCopyContractDialog,
            (dialog) => {
                if(dialog && dialog?.open) {
                    return true;
                }
                return false;
            }
        );

        const selectContractId = createSelector(
            selectCopyContractDialog,
            (dialog) => {
                if(dialog && dialog?.existingContractId) {
                    return dialog.existingContractId;
                }
                return null;
            }
        );

        const selectExistingContractName = createSelector(
            selectCopyContractDialog,
            (dialog) => {
                if(dialog && dialog?.existingContractName) {
                    return dialog.existingContractName;
                }
                return null;
            }
        );

        const selectExistingContractStateId = createSelector(
            selectCopyContractDialog,
            (dialog) => {
                if(dialog && dialog?.existingContractStateId) {
                    return dialog.existingContractStateId;
                }
                return null;
            }
        );

        const selectFeeScheduleRules = createSelector(
            state => state.rules.rulesByContractId,
            (rulesByContractId: any) => rulesByContractId.filter(item => (item?.feeScheduleId || item?.globalFeeScheduleId))
            
        )

        const selectFeeScheduleRulesGroups = createSelector(
            state => state.rules.rulesByContractId,
            (rulesByContractId: any) => {
                return rulesByContractId.filter(item => item.ruleFeeScheduleGroupXref !== null)
            }
        )

        const selectLesserOfRules = createSelector(
            state => state.rules.rulesByContractId,
            (rulesByContractId: any) => {
                return rulesByContractId.filter(item =>
                    item.lesserOfConfiguration &&
                    item.lesserOfConfiguration.length > 0 &&
                    item.lesserOfConfiguration.some(config => config.lesserOfType === 'FeeSchedule')
                )
            }
        )

        const selectProviderRoleRules = createSelector(
            state => state.rules.rulesByContractId,
            (rulesByContractId: any) => {
                return rulesByContractId.filter(item =>
                    item.useNpiRole &&
                    item.providerRolePaymentGroupXref && 
                    item.providerRolePaymentGroupXref.length > 0 &&
                    item.providerRolePaymentGroupXref.some(item => item.feeScheduleId !== null || item.globalFeeScheduleId !== null)
                )
            }
        )

        const selectCodeServicesRules = createSelector(
            state => state.rules.rulesByContractId,
            (rulesByContractId: any) => {
                return rulesByContractId.filter(item => item.codeServiceId !== null)
            }
        )

        const selectInitialValues = createSelector(
            selectExistingContractName,
            (existingContractName) => {
                return {
                    newContractName: `Copy - ${existingContractName}`,
                    targetFacilities: [],
                    feeScheduleMapping: [],
                    rateLabelMapping:[],
                    codeServiceMapping: [],
                }
            }
        )

        return (state, props) => ({
            open: selectCopyContractDialogOpen(state, props),
            copyContractPending: state.contracts.copyContract.pending,

            clients: selectClientListTiny(state as never),
            selectedClient: selectSelectedClient(state as never),
            selectedClientSchema: selectSelectedClientSchema(state as never),
            isSuperAdmin: selectIsSuperAdmin(state as never),
            contractId: selectContractId(state, props),
            contractName: selectExistingContractName(state, props),
            stateId: selectExistingContractStateId(state, props),
            initialValues: selectInitialValues(state, props),
            feeScheduleRules: selectFeeScheduleRules(state),
            feeScheduleRulesGroups: selectFeeScheduleRulesGroups(state),
            lesserOfRules: selectLesserOfRules(state),
            providerRoleRules: selectProviderRoleRules(state),
            codeServiceRules: selectCodeServicesRules(state),

            getFeeSchdulePending: state.feeScheduleItems.getFeeScheduleFromClient.pending,
            getRulesPending: state.rules.getRulesByContractId.pending,
            hasRulesApiResponded: state.rules.getRulesByContractId.hasApiResponded,
            getCodeServicePending: state.services.getCodeServicesFromTargetClient.pending,
            facilitiesFromTargetClientPending: state.facilities.getFacilitiesFromTargetClient.pending,

            feeSchedulesFromClient: state.feeScheduleItems.feeSchedulesFromClient,
            codeServicesFromClient: state.services.codeServicesFromTargetClient,
            facilitiesFromTargetClient: state.facilities.facilitiesFromTargetClient,

            getFeeScheduleLabelsFromTargetClientsPending: state.feeScheduleV2.getFeeScheduleLabelsFromTargetClients.pending,
            feeScheduleLabelsValidate:state.feeScheduleV2.feeScheduleLabelsValidate,

            getNPIRolesFromContractPending: state.npiRoles.getNpiRolesFromContract.pending,
            getNPIRolesFromClientPending: state.npiRoles.getNpiRolesFromTargetClient.pending,
            npiRolesFromContract: state.npiRoles.npiRolesFromContract,
            npiRolesFromClient: state.npiRoles.npiRolesFromTargetClient,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            clientListTiny: listTiny,
            copyContract: copyContract,
            getRulesByContractId: getRulesByContractId,
            getFeeScheduleFromClient: getFeeScheduleFromClient,
            resetRulesByContractId: resetRulesByContractId,
            getServicesFromTargetClient: getServicesFromTargetClient,
            setCopyContractName: setCopyContractName,
            getFacilitiesByTargetClient: getFacilitiesByTargetClient,
            copyContractReset: copyContractReset,
            setCopyContractDialog: setCopyContractDialog,
            getFeeScheduleLabelsFromTargetClient:getFeeScheduleLabelsFromTargetClient,
            validateLabelsFromTargetClient:validateLabelsFromTargetClient,
            getNPIRolesFromContract: getNPIRolesFromContract,
            getNPIRolesFromTargetClient: getNPIRolesFromTargetClient,
        }, dispatch)
    })
)(injectIntl(CopyContractDialogComponent));